module.exports = __webpack_public_path__ + "img/RightButtonDisabled.56d1aa26.webp";